module.exports = __webpack_public_path__ + "assets/key.bfe34d8c.svg";